import { faqs, contactInfo } from "./data";

const SITE_URL = "https://bwfintechapi.cn/";

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: contactInfo.brand,
  alternateName: "黑料投稿",
  url: SITE_URL,
  inLanguage: "zh-CN",
  description:
    "黑料投稿审核中心公开审核标准、发布规则、处理时长与删除原因，说明从提交到曝光的完整流程。",
  publisher: {
    "@type": "Organization",
    name: contactInfo.brand,
    email: contactInfo.email,
  },
};

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: contactInfo.brand,
  url: SITE_URL,
  email: contactInfo.email,
  description:
    "围绕黑料投稿的审核标准、发布规则与处理时长提供公开说明与投稿指引。",
};

export const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "黑料投稿审核标准与发布规则总览",
  url: SITE_URL,
  inLanguage: "zh-CN",
  description:
    "详解黑料投稿的审核标准、发布规则、处理时长及删除原因，从提交到曝光每一步流程透明可查。",
  isPartOf: { "@type": "WebSite", name: contactInfo.brand, url: SITE_URL },
};

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((item) => ({
    "@type": "Question",
    name: item.q,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.a,
    },
  })),
};